// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { toast } from 'react-toastify';
import { getUrlParameter } from '../config/common';
import * as action from '../Action/Preferences/Preferences_Action';
import * as sendCodeAction from '../Action/Send_Code/Send_Code_Action';
import Loader from './Loader';

const Preferences = ({ setIsEmailSubmit, email, requestHelpData, setRequestHelpData }) => {
	const dispatch = useAppDispatch();
	const preferencesLoading = useAppSelector(state => state.PreferencesReducer);
    const verifyEmailData = useAppSelector(state => state.VerifyEmailReducer);
    const [data] = useState(verifyEmailData.payload.data || {});
	const [errors, setErrors] = useState({});
    const formRef = useRef();
    const companyNameRefFocus = useRef();
    const nameRefFocus = useRef();
    const phoneRefFocus = useRef();
    const jobTitleRefFocus = useRef();

    useEffect(() => {
        if (companyNameRefFocus.current) companyNameRefFocus.current.value = getUrlParameter('company') || '';
        if (nameRefFocus.current) nameRefFocus.current.value = getUrlParameter('name') || '';
        if (phoneRefFocus.current) phoneRefFocus.current.value = getUrlParameter('phone') || '';
        if (jobTitleRefFocus.current) jobTitleRefFocus.current.value = getUrlParameter('jobTitle') || '';
    }, []);

    const updatePreferences = (e) => {
        e.preventDefault();
        const formData = new FormData(formRef.current);
        const formValues = Object.fromEntries(formData.entries());

        formValues.roles = data.roles.filter((item, index) =>
            formRef.current[`role${index}`].checked
        );
        formValues.notificationPreferences = data.notificationPreferences.filter(
            (item, index) => true //formRef.current[`pref${index}`].checked //default check all, AVS-2452
        );
        formValues.businessSegments = data.businessSegments.filter(
            (item, index) => formRef.current[`seg${index}`].checked
        );
        formValues.supportRep = formValues.supportRep === 'on' ? true : false;
        formValues.tpnDirectory = formValues.tpnDirectory === 'on' ? true : false;

		setErrors({})
		let customErrors = {};
		if (formValues.companyName === '' || formValues.companyName.trim().length === 0) {
			customErrors = { ...customErrors, companyName: "Please enter your company name to continue." }
			companyNameRefFocus.current.focus();
		}else if (formValues.name === '' || formValues.name.trim().length === 0) {
			customErrors = { ...customErrors, name: "Please enter your name to continue." }
			nameRefFocus.current.focus();
		}else if (formValues.name.trim().split(' ').length < 2) {
			customErrors = { ...customErrors, name: "First and Last name are required." }
			nameRefFocus.current.focus();
		}else if (formValues.phone === '' || formValues.phone.trim().length === 0) {
			customErrors = { ...customErrors, phone: "Please enter your phone to continue." }
			phoneRefFocus.current.focus();
		}else if (formValues.jobTitle === '' || formValues.jobTitle.trim().length === 0) {
			customErrors = { ...customErrors, jobTitle: "Please enter your job title to continue." }
			jobTitleRefFocus.current.focus();
		}
		if (Object.keys(customErrors).length > 0) {
			setErrors(customErrors)
			return true
		}
		if (formValues.roles.length === 0) {
			toast.error("Please select role to continue.");
            return;
		}
		if (!formValues.seniority || formValues.seniority.trim().length === 0) {
			toast.error("Please select seniority to continue.");
            return;
		}
		if (formValues.notificationPreferences.length === 0) {
			toast.error("Please select notification preference to continue.");
            return;
		}
        
        // eslint-disable-next-line no-unused-vars
        var url = new URL(window.location.href);
        let originUrls = window.location.ancestorOrigins;
        if (originUrls) {
            originUrls = originUrls.length > 0 ? originUrls[originUrls.length - 1] : '';
        }
        let param = {
            role: formValues.roles.join(";"),
            seniority: formValues.seniority,
            notification: formValues.notificationPreferences.join(";"),
            businessSegment: formValues.businessSegments.join(";"),
            tpnDirectory: formValues.tpnDirectory,
            url: originUrls ? originUrls : ((window.location !== window.parent.location) ? document.referrer : document.location.href),
            email: email,
            name: formValues.name,
            companyName: formValues.companyName,
            supportRep: formValues.supportRep,
            phone: formValues.phone,
            jobTitle: formValues.jobTitle
        }
        // ACOP-157: this person has no sign-in yet, so the survey registers (create-only) rather than edits.
        dispatch(action.registerPreferences({ data: JSON.stringify(param) })).then((response) => {
            if (response.status !== 1) {
                toast.error(response.message);
                return;
            }
            sendCode();
            setIsEmailSubmit('verify');
		}).catch(error => {
            console.log(error);
			toast.error(error.message || 'Failed to save preferences. Please try again.');
		})

        const sendCode = () => {
            let param = {
                email: email
            }
            dispatch(sendCodeAction.sendCode({ data: JSON.stringify(param) })).then((response) => {
                if (response.status !== 1) {
                    toast.warn('Code may not have been sent. Use "Resend Code" if needed.');
                }
            }).catch(error => {
                console.log(error);
                toast.warn('Code may not have been sent. Use "Resend Code" if needed.');
            })
        }
    }

    const showNeedHelpModal = () => {
        const formData = new FormData(formRef.current);
        const formValues = Object.fromEntries(formData.entries());

        setRequestHelpData({
            ...requestHelpData,
            name: formValues.name,
            email: email,
            company: formValues.companyName,
            phone: formValues.phone,
            showNeedHelpModal: true
        });
    }

    return(
        <>
            {
                preferencesLoading.loading ? <Loader /> :
                <>
                    <div className="row mx-2 my-3">
                        <div className="col-md-12">
                            <h5>Welcome to AvSight Copilot</h5>
                            <p>In order to serve you better please fill out the following short survey. This information will help us to create an account for you and provide relevant information tailored to your role.</p>
                            <form ref={formRef} onSubmit={updatePreferences}>
                                <div className="row mt-4">
                                    <div className="col-12 mb-3">
                                        <h6>Email</h6>
                                        <input className="form-control" type="text" value={email} disabled readOnly />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <h6>Company</h6>
                                        <input className="form-control" ref={companyNameRefFocus} type="text" name='companyName' maxLength="255" />
                                        <span style={{ color: 'red' }}>{errors?.companyName}</span>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <input className="form-check-input" type="checkbox" name='supportRep' value={data.isSupportRep} id="supportRep" />
                                        <label className="form-check-label ps-1" htmlFor="supportRep">
                                            I am the AvSight Support Rep
                                        </label>
                                    </div>
                                    <div className="col-12 mb-4">
                                        <h6>Your Full Name</h6>
                                        <input className="form-control" ref={nameRefFocus} type="text" name='name' maxLength="255" data-testid="preferences-name-input" />
                                        <span style={{ color: 'red' }} data-testid="preferences-name-error">{errors?.name}</span>
                                    </div>
                                    <div className="col-12 mb-4">
                                        <h6>Your Job Title</h6>
                                        <input className="form-control" ref={jobTitleRefFocus} type="text" name='jobTitle' maxLength="255" />
                                        <span style={{ color: 'red' }}>{errors?.jobTitle}</span>
                                    </div>
                                    <div className="col-12 mb-4">
                                        <h6>Contact #</h6>
                                        <input className="form-control" ref={phoneRefFocus} type="text" name='phone' maxLength="255" />
                                        <span style={{ color: 'red' }}>{errors?.phone}</span>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <h6>Role</h6>
                                        {
                                            data.roles && data.roles.map((item, index) => {
                                                return(
                                                    <div key={index}>
                                                        <input className="form-check-input" type="checkbox" name='roles' value={item} checked={data.selRoles && data.selRoles.indexOf(item) !== -1} id={`role${index}`} />
                                                        <label className="form-check-label ps-1" htmlFor={`role${index}`}>
                                                            {item}
                                                        </label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <h6>Seniority</h6>
                                        {
                                            data.seniorities && data.seniorities.map((item, index) => {
                                                return(
                                                    <div key={index}>
                                                        <input className="form-check-input" type="radio" name='seniority' value={item} checked={data.selSenioirty && data.selSenioirty === item} id={`seniority${index}`} />
                                                        <label className="form-check-label ps-1" htmlFor={`seniority${index}`}>
                                                            {item}
                                                        </label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <div className="col-md-3 mb-4">
                                        <h6>Notification Preferences</h6>
                                        {
                                            data.notificationPreferences && data.notificationPreferences.map((item, index) => {
                                                return(
                                                    <div key={index}>
                                                        <input className="form-check-input" type="checkbox" name='notificationPreferences' value={item} defaultChecked={data.selNotification && data.selNotification.indexOf(item) != -1} id={`pref${index}`} />
                                                        <label className="form-check-label ps-1" htmlFor={`pref${index}`}>
                                                            {item}
                                                        </label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div> */}
                                    <div className="col-md-4 mb-4">
                                        <h6>Business Segments</h6>
                                        {
                                            data.businessSegments && data.businessSegments.map((item, index) => {
                                                return(
                                                    <div key={index}>
                                                        <input className="form-check-input" type="checkbox" name='businessSegments' value={item} checked={data.selBusinessSegments && data.selBusinessSegments.indexOf(item) !== -1} id={`seg${index}`} />
                                                        <label className="form-check-label ps-1" htmlFor={`seg${index}`}>
                                                            {item}
                                                        </label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-12">
                                        <button type="button" className="btn btn-primary me-2 btn-block" onClick={(e) => { setIsEmailSubmit('email')  }} >Back</button>
                                        <button className="btn btn-primary btn-block" data-testid="preferences-continue-btn">Continue</button>
                                        <button type='button' className="btn btn-secondary btn-block ms-2" onClick={(e) => showNeedHelpModal()}>Need help?</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            }
        </>
    );
}

export default Preferences;